import { HStack, VStack } from '@chakra-ui/react';

/**
 * Primary vertical container for form layouts with spacing and background.
 */
export function FormMainContainer({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <VStack w="full" minH="full" justify="space-between" align="center" bg="bg.surface">
      {children}
    </VStack>
  );
}

/**
 * Scrollable content area for form components with consistent padding.
 */
export function FormContentContainer({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <VStack gap="8px" w="full" flex="1" px="24px" py="8px" overflowY="visible">
      {children}
    </VStack>
  );
}

/**
 * Action bar container for form footers with reverse-ordered horizontal layout.
 */
export function FormFooterContainer({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <HStack
      w="full"
      justify="space-between"
      flexDirection="row-reverse"
      bg="bg.subtle"
      borderTop="1px"
      borderColor="border.default"
      px="24px"
      py="16px"
    >
      {children}
    </HStack>
  );
}
